<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap" :class="classes">
      <vs-row vs-type="flex" vs-w="12" vs-justify="space-between" vs-align="center" >
        <vs-col vs-type="flex" vs-lg="3" vs-sm="6" vs-xs="12" vs-align="center">
          <a href="https://www.i9advisory.com/" target="_blank" rel="nofollow">
            <img src="@/assets/images/logo/i9_logo_transparent.png" width="90" height="100">
          </a>
          <span>| Todos os direitos reservados.</span>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="12" vs-align="center">
          <p >
            Em caso de dúvidas, por favor, entre contato com a equipe de suporte: <b>suporte-credito@i9advisory.com.br</b>
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="6" vs-xs="12" vs-align="center">
          <p >
            Desenvolvido por I9 Sistemas
          </p>
         </vs-col>
       </vs-row>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
